import React, { Fragment } from 'react'
import Helmet from 'react-helmet'

const RegulationDefault = () => (
  <Fragment>
    <Helmet>
      <title>{`Regulamentos - ${process.env.REACT_APP_TITLE || ''}`}</title>
    </Helmet>
    <div className='container-fluid bg-color-ui-4'>
      <div className='container'>
        <div className='row py-3'>
          <div className='col-12 px-1 px-md-2'>
            <div className='row mx mx-md-0'>
              <div className='regulation col-12 bg-white border-ui-3 radius-0 radius-md'>
                <div className='title'>
                  <div className='col-12 px-3 py-3 txt-center'>
                    <h3 className='txt-bold txt-uppercase py-1'>Regulamento</h3>
                    <h2 className='pt-1'>"Vale Mais PETRONAS"</h2>
                    <h4 className='company-name txt-body-sm py-1'>PETRONAS LUBRIFICANTES BRASIL S.A</h4>
                    <p className='txt-body-sm'><strong className='txt-font-body color-ui-black'>Avenida Trajano de Araujo Viana nº 2500</strong></p>
                    <p className='txt-body-sm py-1'><strong className='txt-font-body color-ui-black'>Contagem - MG - CEP 32010-090</strong></p>
                    <p className='txt-body-sm'><strong className='txt-font-body color-ui-black'>CNPJ/MF: <strong>03.613.421/0001-86</strong></strong></p>
                  </div>
                </div>
                <div className='col-12 px-2 px-md-3 py-3' role='article'>
                  <p className='txt-body-sm txt-uppercase mb-1'>
                    <strong>Regulamentos</strong>
                  </p>
                  <p className='txt-body-sm mb-2'>
                  O catálogo de prêmios, disponível para acesso em
                    <strong>{ window.location.host }</strong> ou por meio de redirecionamento
                  diretamente do hotsite de Programas de Relacionamento,
                  Campanhas de Incentivo e Ações (“Premmiar” ou
                  “Plataforma”), é uma plataforma online que permite a você
                  (doravante “Usuário”), participante de determinada campanha de
                  incentivo, desenvolvida por um gestor de campanhas,
                  contratante da Premmiar (“Gestor”), trocar seus pontos
                  adquiridos em tal campanha por produtos ou serviços
                  disponibilizados por nossas empresas parceiras (“Parceiros”),
                  indicadas na Plataforma.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  Dessa forma, os presentes Termos de Uso (“Termos”) estipulam
                  as regras para utilização da Plataforma pelos Usuários, e
                  estão disponíveis para acesso, a qualquer momento, por meio do
                  link{' '}
                    <a
                      href='/terms'
                      target='_blank'
                      className='txt-body-sm'
                    >
                      <strong>{ window.location.host }/terms</strong>
                    </a>
                  .
                  </p>

                  <p className='txt-body-sm mb-2'>
                  Aplicam-se aos presentes Termos, ainda, o quanto disposto na
                  Política de Privacidade, disponível para acesso em{' '}
                    <a
                      href='/privacy'
                      target='_blank'
                      className='txt-body-sm'
                    >
                      <strong>{ window.location.host }/privacy</strong>
                    </a>
                  .
                  </p>

                  <p className='txt-body-sm mb-2'>
                  Em caso de quaisquer dúvidas sobre o quanto disposto nestes
                  Termos, o Usuário deverá entrar em contato com a Premmiar por
                  meio da página “Fale Conosco”, disponível em{' '}
                    <a
                      href='/redirect/contact'
                      target='_blank'
                      className='txt-body-sm'
                    >
                      <strong>{ window.location.host }/redirect/contact</strong>
                    </a>
                  .
                  </p>
                  <p className='txt-body-sm txt-uppercase mb-1'>
                    <strong>1. ACEITAÇÃO DESTES TERMOS</strong>
                  </p>
                  <p className='txt-body-sm mb-2'>
                  1.1. A presente Campanha constituindo-se em um Ato Unilateral com promessa de recompensa, conforme o disposto nos artigos 854 e seguintes do Código Civil, sendo realizada em todo o território nacional, durante o período de 01 de julho de 2020 a 30 de setembro de 2020.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  1.2. Esta Campanha será direcionada aos pontos de venda participantes do programa de relacionamento "Vale Mais PETRONAS", pertencentes as categorias Gold, Platinum e Titanium e que comercializam produtos PETRONAS Syntium, PETRONAS Sprinta e PETRONAS Urania, nas versões Mineral, Semissintético e Sintético.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  1.3. A finalidade desta Campanha é incentivar, motivar, relacionar, fidelizar, monitorar e incrementar as vendas dos produtos PETRONAS exclusivamente por meio dos pontos de venda participantes, recompensando-as desde que sejam cumpridas todas as condições aqui definidas.
                  </p>
                  <p className='txt-body-sm txt-uppercase mb-1'>
                    <strong>2. DA PARTICIPAÇÃO</strong>
                  </p>
                  <p className='txt-body-sm mb-2'>
                  2.1. Poderão participar desta campanha os pontos de venda dos canais relacionados abaixo, que comercializam produtos PETRONAS, participantes do programa de relacionamento "Vale Mais PETRONAS", desde que pertencentes as categorias e canais abaixo mencionados e observadas as demais regras de participação adiante estabelecidas:
                    <p className='txt-body-sm my-1'>Categorias: Titanium, Platinum e Gold</p>
                    <ol> Canais:
                      <li className='txt-body-sm mt-1'>1. Autopeça</li>
                      <li className='txt-body-sm'>2. Centro Automotivo</li>
                      <li className='txt-body-sm'>3. Concessionaria </li>
                      <li className='txt-body-sm'>4. Loja de Pneu</li>
                      <li className='txt-body-sm'>5. Oficina Mecânica</li>
                      <li className='txt-body-sm'>6. Troca de óleo</li>
                    </ol>
                  </p>
                  <p className='txt-body-sm mb-2'>
                  Para participar desta campanha, os pontos de venda elegíveis deverão, durante o período de participação, realizar compras de produtos PETRONAS elegíveis junto ao seu respectivo Distribuidor Autorizado PETRONAS.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  2.3. Fica desde já estabelecido que a venda de 01 (um) litro de um produto PETRONAS gerará uma quantidade de pontos previamente determinada, conforme abaixo:

                    <div className='container'>
                      <div className='row justify-content-center'>
                        <div className='col-12 col-lg-8 txt-center py-2'>
                          <div className='row txt-bold align-items-center pb-1'>
                            <div className='col'>TIPO</div>
                            <div className='col'>Mineral</div>
                            <div className='col'>Semissintético</div>
                            <div className='col'>Sintético</div>
                          </div>

                          <div className='row align-items-center pb-1'>
                            <div className='col'>
                              <p>PETRONAS</p>
                              <p>SYNTIUM</p>
                            </div>
                            <div className='col'>1 ponto</div>
                            <div className='col'>3 pontos</div>
                            <div className='col'>5 pontos</div>
                          </div>

                          <div className='row align-items-center pb-1'>
                            <div className='col'>
                              <p>PETRONAS</p>
                              <p>URANIA</p>
                            </div>
                            <div className='col'>1 ponto</div>
                            <div className='col'>3 pontos</div>
                            <div className='col'>5 pontos</div>
                          </div>

                          <div className='row align-items-center'>
                            <div className='col'>
                              <p>PETRONAS</p>
                              <p>URANIA</p>
                            </div>
                            <div className='col'>1 ponto</div>
                            <div className='col'>3 pontos</div>
                            <div className='col'>5 pontos</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p>*Lista com detalhe de produtos participantes no <a href='#anexo1'>anexo 1.</a></p>
                  </p>

                  <p className='txt-body-sm mb-2'>
                  2.4. Para efetivação da participação e atribuição dos pontos gerados, o representante do ponto de venda deverá acessar o site <a href='http://www.valemaispetronas.com.br/'>www.valemaispetronas.com.br</a>, fazer o login na área reservada para esta campanha e cadastrar as informações de acordo com os dados ali solicitados.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  2.4.1. Caso seja o primeiro acesso ao site da campanha e o ponto de venda não seja participante do “Vale Mais PETRONAS” deverá efetuar o seu cadastro informando os dados solicitados, aceitar os termos do regulamento, além de criar um login e senha para futuros acessos visando consultas, novos cadastros e/ou resgates. Após essa etapa o cadastro será validado pela PETRONAS caso o ponto de venda atenda os critérios de participação.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  2.4.2. Mesmo sendo membro do “Vale Mais PETRONAS” no primeiro acesso para a efetivação de sua participação nesta campanha, será necessário indicar o aceite aos termos deste regulamento.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  2.4.3. O ponto de venda somente será considerado participante do programa de relacionamento “Vale Mais PETRONAS” após realizar o cadastro acima, sendo que os pontos somente serão contabilizados para compras realizadas após a efetivação do mesmo cadastro.
                  </p>

                  <p className='txt-body-sm txt-uppercase mb-1'>
                    <strong>3. DO RESGATE</strong>
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.1. Os pontos de venda participantes, desde que observadas as regras deste Regulamento, poderão realizar o resgate da pontuação através do site <a href='http://www.valemaispetronas.com.br/'>www.valemaispetronas.com.br</a>, até dia 31 de outubro de 2020. Após esse prazo todos os pontos acumulados serão automaticamente expirados.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.1.1. Os pontos serão creditados em até 15 (quinze) dias úteis do mês subsequente de compra do ponto de vendas junto ao Distribuidor Autorizado PETRONAS. Os pontos provenientes de produtos de pedidos devolvidos ou cancelados pelo ponto de venda ao Distribuidor Autorizado PETRONAS nesse período, em nenhuma hipótese, serão computados, para fins desta campanha.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.2 As Revendas participantes que possuírem o cadastro, ou seja, que também participam do “Vale Mais PETRONAS”, além de acumularem a pontuação obtida, poderão optar pelo resgate mínimo de 400 pontos em produtos PETRONAS ou ainda, a pontuação necessária para cada para item disponível no Catálogo de produtos dentro do site <a href='http://www.valemaispetronas.com.br/'>www.valemaispetronas.com.br</a>.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.2.1. Para ter acesso as condições de resgate de produtos disponíveis no Catálogo do “Vale Mais PETRONAS” basta acessar o site <a href='http://www.valemaispetronas.com.br/'>www.valemaispetronas.com.br</a>, onde também está disponível o regulamento completo da referida Campanha.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.2.2. A validade e condições de regaste dos pontos para os participantes do “Vale Mais PETRONAS” seguirão as regras do regulamento do referido programa de relacionamento.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.3. Após cumprir as condições, na forma acima descrita, o ponto de venda participante, através de seu representante, poderá realizar o resgate acessando o site da Campanha “Vale Mais PETRONAS” e seguir as orientações de resgate.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.3.1. No próprio site, ao escolher o produto que deseja e estando disponível, deverá confirmar o endereço para a sua entrega.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.4. O produto escolhido no momento do resgate será entregue sem custo adicional no endereço indicado em até 45 dias da confirmação da transação de resgate realizada na forma deste regulamento.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.4.1. O produto será entregue em embalagem lacrada, em perfeito estado de uso, devendo o representante do ponto de venda verificar a sua integridade no momento de seu recebimento. Em caso de defeito, entrar em contato imediatamente após o seu recebimento com a Realizadora através de contato com a central de atendimento no telefone (11) 3514-7678.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  3.5. Não será permitida a comercialização e/ou troca de produto exclusivo PETRONAS escolhido no momento do resgate por qualquer outro, tampouco sua conversão em dinheiro.
                  </p>

                  <p className='txt-body-sm txt-uppercase mb-1'>
                    <strong>4. DIVULGAÇÃO DA CAMPANHA</strong>
                  </p>

                  <p className='txt-body-sm mb-2'>
                  4.1. A Campanha será divulgada através dos Distribuidores Autorizados PETRONAS junto aos pontos de venda que comercializam produtos PETRONAS e outros meios a critério exclusivo da empresa realizadora.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  4.2. Este regulamento estará disponível na íntegra no site <a href='http://www.valemaispetronas.com.br/'>www.valemaispetronas.com.br</a>
                  </p>

                  <p className='txt-body-sm txt-uppercase mb-1'>
                    <strong>5. CONSIDERAÇÕES GERAIS</strong>
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.1. A participação nesta Campanha implica na aceitação total de todos os itens deste Regulamento, que poderá ser alterado pela Realizadora tantas vezes quanto necessário, a seu exclusivo critério, com posterior divulgação.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.2. A Campanha, por exclusivo critério da Realizadora, poderá ser interrompida ou encerrada a qualquer tempo. Nesses casos, todas as informações pertinentes serão amplamente divulgadas.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.3. Serão automaticamente desclassificados os participantes que descumprirem os itens do presente regulamento, agirem de má-fé ou que, de alguma forma, burlarem as regras e condições deste Regulamento ou utilizarem mecanismos fraudulentos ou ilícitos.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.4. Os pontos de venda participantes, por meio de seus representantes legais, e os demais participantes, concordam em autorizar o uso de suas imagens, nomes e dados pessoais, em relatórios, filmes, vídeos, mídias sociais, fotos e cartazes, anúncios em jornais e revistas, pelo prazo 5 (cinco) ano após o encerramento desta Campanha, para divulgação de sua participação, bem como do resgate de produtos conforme condições aqui estabelecidas, sem nenhum ônus para a Realizadora.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.4.1. As autorizações descritas acima não implicam em qualquer obrigação de divulgação ou de pagamento de qualquer quantia por parte da Realizadora.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.5. A participação nesta Campanha é voluntária, facultativa e gratuita, não havendo qualquer sanção àquelas Revendas que optarem por não participar.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.6. As dúvidas não esclarecidas pelo presente Regulamento serão dirimidas por um Comitê Interno da Realizadora, de forma soberana e irrecorrível.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.7. A Realizadora não será responsabilizada por qualquer evento decorrente de caso fortuito ou força maior, nos termos da lei.
                  </p>

                  <p className='txt-body-sm mb-2'>
                  5.8. Fica eleito o foro da Comarca de Belo Horizonte/MG como competente para solucionar quaisquer questões oriundas do presente Regulamento.
                  </p>

                  <p id='anexo1' className='txt-body-sm txt-uppercase mb-1'>
                    <strong>ANEXO 1 - [LISTA DE PONTOS POR PRODUTO]</strong>

                    <div className='container'>
                      <div className='row justify-content-center my-3'>
                        <div className='col'>
                          <p className='txt-body txt-bold pb-1'>CÓDIGO</p>
                          <p className='txt-body-sm'>2054B091J</p>
                          <p className='txt-body-sm'>2B54B091J</p>
                          <p className='txt-body-sm'>2057B087J</p>
                          <p className='txt-body-sm'>20541100J</p>
                          <p className='txt-body-sm'>2057B091J</p>
                          <p className='txt-body-sm'>2B57B091J</p>
                          <p className='txt-body-sm'>2053B091J</p>
                          <p className='txt-body-sm'>2046B091J</p>
                          <p className='txt-body-sm'>2B46B091J</p>
                          <p className='txt-body-sm'>2048B091J</p>
                          <p className='txt-body-sm'>2B51B091J</p>
                          <p className='txt-body-sm'>2051B091J</p>
                          <p className='txt-body-sm'>1C21B091J</p>
                          <p className='txt-body-sm'>1C20B091J</p>
                          <p className='txt-body-sm'>1C211100J</p>
                          <p className='txt-body-sm'>1C201100J</p>
                          <p className='txt-body-sm'>1C22B091J</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>1817B091J</p>
                          <p className='txt-body-sm'>1C19B091J</p>
                          <p className='txt-body-sm'>1833B091J</p>
                          <p className='txt-body-sm'>1816B091J</p>
                          <p className='txt-body-sm'>18161100J</p>
                          <p className='txt-body-sm'>18171100J</p>
                          <p className='txt-body-sm'>1C191100J</p>
                          <p className='txt-body-sm'>1C17B091J</p>
                          <p className='txt-body-sm'>1C171100J</p>
                          <p className='txt-body-sm'>1815B091J</p>
                          <p className='txt-body-sm'>18871100J</p>
                          <p className='txt-body-sm'>1807B091J</p>
                          <p className='txt-body-sm'>1887B091J</p>
                          <p className='txt-body-sm'>18071100J</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>18151100J</p>
                          <p className='txt-body-sm'>1886B091J</p>
                          <p className='txt-body-sm'>1B07B091J</p>
                          <p className='txt-body-sm'>18541100J</p>
                          <p className='txt-body-sm'>18121100J</p>
                          <p className='txt-body-sm'>1854B091J</p>
                          <p className='txt-body-sm'>18861100J</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>1812B091J</p>
                          <p className='txt-body-sm'>18361100J</p>
                          <p className='txt-body-sm'>1855B091J</p>
                          <p className='txt-body-sm'>1813B091J</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>21811910J</p>
                          <p className='txt-body-sm'>21841910J</p>
                          <p className='txt-body-sm'>21841100J</p>
                          <p className='txt-body-sm'>2184B091J</p>
                          <p className='txt-body-sm'>21861910J</p>
                          <p className='txt-body-sm'>21871100J</p>
                          <p className='txt-body-sm'>21851100J</p>
                          <p className='txt-body-sm'>1C231100J</p>
                          <p className='txt-body-sm'>21871910J</p>
                          <p className='txt-body-sm'>2181B091J</p>
                          <p className='txt-body-sm'>21791100J</p>
                          <p className='txt-body-sm'>21711100J</p>
                          <p className='txt-body-sm'>21851910J</p>
                          <p className='txt-body-sm'>21371100J</p>
                          <p className='txt-body-sm'>21861100J</p>
                          <p className='txt-body-sm'>2B301910J</p>
                          <p className='txt-body-sm'>21711910J</p>
                          <p className='txt-body-sm'>N/A</p>
                          <p className='txt-body-sm'>21811100J</p>
                          <p className='txt-body-sm'>13531100J</p>
                          <p className='txt-body-sm'>21791910J</p>
                          <p className='txt-body-sm'>2179B091J</p>
                          <p className='txt-body-sm'>21371910J</p>
                          <p className='txt-body-sm'>13531910J</p>
                          <p className='txt-body-sm'>2137B091J</p>
                          <p className='txt-body-sm'>1C231910J</p>
                          <p className='txt-body-sm'>2186B091J</p>
                          <p className='txt-body-sm'>21781100J</p>
                          <p className='txt-body-sm'>21781910J</p>
                          <p className='txt-body-sm'>21031910J</p>
                          <p className='txt-body-sm'>21031100J</p>
                          <p className='txt-body-sm'>13391100J</p>
                          <p className='txt-body-sm'>13391910J</p>
                          <p className='txt-body-sm'>13471100J</p>
                          <p className='txt-body-sm'>21821100J</p>
                          <p className='txt-body-sm'>13471910J</p>
                          <p className='txt-body-sm'>21831910J</p>
                        </div>

                        <div className='col'>
                          <p className='txt-body txt-bold pb-1'>LINHA</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Mineral</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Semissintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                          <p className='txt-body-sm'>Sintético</p>
                        </div>

                        <div className='col-2'>
                          <p className='txt-body txt-bold pb-1'>MARCA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SPRINTA</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>SYNTIUM</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                          <p className='txt-body-sm'>URANIA</p>
                        </div>

                        <div className='col-5'>
                          <p className='txt-body txt-bold pb-1'>DESCRIÇÃO PRODUTO</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F300 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F300 ULT. 20W50 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA T300 (24X0,5L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F300 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA T300 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA T300 ULT. (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F500 10W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F500 15W50 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F500 15W50 ULT. (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F700 E 10W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F900 ULT. 10W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SPRINTA F900 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 300 20W50 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 500 15W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 300 20W50 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 500 15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 300 25W60 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 500 20W50 API SN (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 500 20W50 APISN(1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 15W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 SE SN+ 15W40(24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 HM 15W50 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 1000 10W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 1000 10W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 SE SN+15W40(1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 SE SN+10W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 800 SE SN+10W30(1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 5W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 XS 5W30 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 FR 5W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 XS 5W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 FR 5W30 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 7000 HYBRID SN+ (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 5W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 5000 DX 5W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 FR MZD 5W30(24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 BV 5W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 7000 0W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 BV 5W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 5000 DX 5W30 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 7000 HYBRID SN+ (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 7000 0W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 7000 0W20 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 7000 E 0W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 5000 AV 5W30 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 5000 FR 5W20 (24x1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 E 5W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS SYNTIUM 3000 E 5W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 1000 15W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000 SE 15W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000 SE 15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000 SE 15W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 800 25W60 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 800 25W50 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 1000 HM 20W50 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000E CI-4+15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 800 25W50 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 1000 15W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000 15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA CF 40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 1000 HM 20W50 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 500 40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 800 25W60 (1X200L)</p>
                          <p className='txt-body-sm'>URANIA 3000 LS 15W-40 CK-4 (1x20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA CF 40 (1X20L)</p>
                          <p className='txt-body-sm'>URANIA 3000 LS 15W-40 CK-4 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 1000 15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA LD 7 15W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000 15W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000 15W40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 500 40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA LD 7 15W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 500 40 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 3000E CI-4+15W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 800 25W60 (24X1L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 5000 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 5000 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA K 10W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA K 10W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 100 K 10W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 100 K 10W40 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA F.E. 5W30 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 5000 SE 10W40 (1X200L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA F.E. 5W30 (1X20L)</p>
                          <p className='txt-body-sm'>PETRONAS URANIA 5000 F 5W30 (1X20L)</p>
                        </div>

                        <div className='col-2'>
                          <p className='txt-body txt-bold pb-1'>EMBALAGEM</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>1 Litro </p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Tambor 200 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                          <p className='txt-body-sm'>Bombona 20 L</p>
                        </div>
                      </div>
                    </div>
                  </p>

                  <p className='txt-body-sm mb-2'>
                  Última atualização: 07/02/2020
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
)

export default RegulationDefault



// WEBPACK FOOTER //
// ./src/features/Regulation/RegulationPetronas.js